// extracted by mini-css-extract-plugin
export var wrapper = "GridOverlay-module--wrapper--3wuHv";
export var cell = "GridOverlay-module--cell--5vNwS";
export var inner = "GridOverlay-module--inner--pFpXk";